import * as Yup from 'yup';
import { INVALID_FIELDS, YupString } from './general';

export const SystemSchema = Yup.object().shape({
  name: YupString,
  // releaseType: YupString.nonNullable(),
  releaseDate: YupString.nonNullable(),
  tasks: Yup.array()
    .of(
      Yup.object().shape({
        taskName: YupString,
        link: YupString,
        createdAt: YupString,
        assignee: Yup.array().min(1, INVALID_FIELDS.MIN_SYSTEM).of(YupString),
      }),
    )
    .required(INVALID_FIELDS.REQUIRED)
    .min(1, INVALID_FIELDS.MIN_SYSTEM),
});
